module.exports = __webpack_public_path__ + "assets/account-role.e8976ee2.svg";